import { Avatar } from "@mui/material";
import pic from "../assets/download.jpeg";
import { useSelector } from "react-redux";
const Profile = () => {
  const videos = useSelector((state) => state);
  console.log("videos", videos);
  return (
    <div className="flex flex-col justify-center bg-black h-screen">
      <div className="flex flex-col w-3/12 justify-center ml-auto mr-auto h-screen md:w-5/6 lg:w-3/12 sm:w-5/6  sm:mt-10 xs:w-5/6">
        <Avatar
          alt="Remy Sharp"
          src={pic}
          sx={{
            width: 280,
            height: 280,
            border: "1px solid rgba(93, 89, 86, 0.65)",
            boxShadow: "0 4px 10px rgba(125, 120, 120, 0.8)",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        />
        <p className="text-white text-center pt-6 text-lg">Alex Beltin</p>
        <div
          className="flex flex-row justify-between text-white text-lg"
          style={{ marginTop: "45px" }}
        >
          <p>Email</p>
          <p>alexBeltin@gmail.com</p>
        </div>

        <div className="flex flex-row justify-between text-white pt-4 text-lg">
          <p>Location</p>
          <p>United State</p>
        </div>
        <div className="flex flex-row justify-between text-white pt-4 text-lg">
          <p>Age</p>
          <p>23</p>
        </div>
        <div className="flex flex-row justify-between text-white pt-4 text-lg">
          <p>Subscribers</p>
          <p>20</p>
        </div>
      </div>
    </div>
  );
};

export default Profile;
